var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`landing-${_vm.type}`},[(_vm.type === 'roller')?_c('div',{staticClass:"loading"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')]):(_vm.type === 'ring')?_c('div',{staticClass:"loading"},[_c('div'),_c('div'),_c('div')]):_c('div',{staticClass:"loading"},[_c('div'),_c('div')])])
}
var staticRenderFns = []

export { render, staticRenderFns }